import React from 'react'

// Material.ui
import Drawer from '@mui/material/Drawer'

function DrawerType(props) {
  const {
    setDrowerOpen = null,
    open = null,
    content = null,
    setSelectRoom = null,
    setIdSelectRoom = null,
    titleHeader = null,
    anchor = 'left',
    color = null,
  } = props

  function clickDrawer() {
    if (setDrowerOpen) setDrowerOpen(!open)
    if (setIdSelectRoom) setIdSelectRoom(false)
    if (setSelectRoom) setSelectRoom(false)
  }

  return (
    <Drawer anchor={anchor} open={open} onClose={clickDrawer}>
      {titleHeader && (
        <div
          style={{
            // laranja da marca como padrao; o oliva daqui pintava o cabecalho de todo
            // modal que nao passava cor (Editar Pet, Taxi Dog, Bloqueio, Comissao)
            background: `${color || '#d05d02'}`,
            color: '#fff',
            padding: '10px',
            fontSize: '18px',
          }}
        >
          {titleHeader}
        </div>
      )}
      {content}
    </Drawer>
  )
}

export default DrawerType
